/**
 * Chrome shared by every card face in the wallet.
 *
 * The panel across the bottom of a pass is a fixed height rather than one
 * measured from its contents. A deck is a set of one kind of object, and the
 * eye reads the seam between photograph and panel as the card's proportions —
 * so a panel that grows or shrinks with what happens to be printed on it makes
 * the cards look like different sizes as you swipe through them, which is
 * exactly what the how-to card at the back was doing with its two short lines.
 *
 * 11rem is the height a fully loaded pass panel comes to on its own: the code's
 * clearance, the progress bar, the programme and expiry fields, and the reward
 * line. Front-face fields truncate; the back reserves the whole panel for the
 * complete reward. A card carrying less simply has slack at the bottom.
 */
export const CARD_PANEL_HEIGHT = "h-44";
